<template>
  <div class="section-pick-tabs__container web-version">
    <TabsBlack :tabs="tabs" />
  </div>
</template>

<script>
import TabsBlack from '@/components/common/tabs/tabs-swift';
import TabNormalPick from '@/components/common/tabs/tab-normal-pick';
// import TabCombinationPick from '@/components/common/tabs/tab-combination-pick';
// import TabSuperQuickPick from '@/components/common/tabs/tab-super-quick-pick';
export default {
  components: {
    TabsBlack
  },
  data () {
    return {
      tabs: [
        {
          title: 'Normal Pick',
          isShow: true,
          isActive: true,
          component: TabNormalPick,
          isTabTitleCustom: false,
          numberTabTitleNotify: 1
        },
        // {
        //   title: 'Combination Pick',
        //   isShow: true,
        //   isActive: false,
        //   component: TabCombinationPick,
        //   isTabTitleCustom: false,
        //   numberTabTitleNotify: 2
        // },
        // {
        //   title: 'Super Quick Pick',
        //   isShow: true,
        //   isActive: false,
        //   component: TabSuperQuickPick,
        //   isTabTitleCustom: false,
        //   numberTabTitleNotify: 3
        // }
      ]
    }
  },
  methods: {}
};
</script>
